import { DialogActions, styled } from '@mui/material';

const StyledDialogActions = styled(DialogActions)`
    border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    background-color: ${({ theme }) => theme.palette.grey[100]};
`;

export default StyledDialogActions;
